<app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

<app-kpi-strip [kpis]="kpis" [active]="activeKpi" (activeChange)="setKpi($event)"></app-kpi-strip>

<div class="table-section">
  <div class="filter-bar filter-bar--flush">
    <div class="filter-card">
      <app-search-pill [value]="searchText" placeholder="Folio, hospital, código, supervisor…" (valueChange)="applySearch($event)"></app-search-pill>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Periodo</mat-label>
        <mat-date-range-input [rangePicker]="periodPicker">
          <input matStartDate [(ngModel)]="periodStart" placeholder="Inicio" (dateChange)="load()">
          <input matEndDate [(ngModel)]="periodEnd" placeholder="Fin" (dateChange)="load()">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="periodPicker"></mat-datepicker-toggle>
        <mat-date-range-picker #periodPicker></mat-date-range-picker>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Hospital</mat-label>
        <mat-select [(value)]="placeFilter" (selectionChange)="load()">
          <mat-option [value]="''">Todos</mat-option>
          @for (p of placeOptions; track p.id) { <mat-option [value]="p.id">{{ p.alias || p.name }}</mat-option> }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Estado</mat-label>
        <mat-select [(value)]="statusFilter" (selectionChange)="load()">
          <mat-option [value]="''">Todos</mat-option>
          @for (s of statuses; track s) { <mat-option [value]="s">{{ s }}</mat-option> }
        </mat-select>
      </mat-form-field>
      <mat-button-toggle-group class="view-toggle" [value]="listView.mode" (change)="listView.set($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
        <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
        <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <app-filter-chips [chips]="filterChips" [count]="dataSource.filteredData.length" [total]="dataSource.data.length" noun="solicitudes" (remove)="removeChip($event)" (clear)="clearFilters()"></app-filter-chips>
  </div>

  <div class="list-actions">
    <button mat-stroked-button (click)="pageLoad.refresh(load())"><mat-icon>refresh</mat-icon> Actualizar</button>
    <button mat-stroked-button (click)="downloadExcel()" [disabled]="!dataSource.filteredData.length"><mat-icon>download</mat-icon> Descargar Excel</button>
    <button mat-flat-button color="primary" (click)="openForm()"><mat-icon>add</mat-icon> Nueva solicitud</button>
  </div>

  <mat-paginator [hidden]="listView.mode !== 'table'" [pageSize]="10" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>

  <ng-template #rowMenu let-r>
    @if (canSupply && (r.status === 'Nueva' || r.status === 'En surtido')) {
      <button mat-menu-item (click)="supply(r)"><mat-icon>travel_explore</mat-icon> Surtir</button>
    }
    @if (canSupply && (r.status === 'Nueva' || r.status === 'En surtido')) {
      <button mat-menu-item (click)="changeStatus(r, 'No aprobada')"><mat-icon>block</mat-icon> No aprobada</button>
    }
    @if (canSupply && (r.status === 'Nueva' || r.status === 'No aprobada')) {
      <button mat-menu-item (click)="changeStatus(r, 'En surtido')"><mat-icon>local_shipping</mat-icon> En surtido</button>
    }
    @if (canCancel(r)) {
      <button mat-menu-item (click)="changeStatus(r, 'Cancelada')"><mat-icon>cancel</mat-icon> Cancelada</button>
    }
    @if (r.status !== 'Recibida' && r.status !== 'Cancelada') {
      <button mat-menu-item disabled matTooltip="Se marca sola al registrar la entrada de delivery ligada a esta solicitud">
        <mat-icon>move_to_inbox</mat-icon> Recibida (al recibir el delivery)
      </button>
    }
    @if (r.statusNote) {
      <button mat-menu-item disabled><mat-icon>notes</mat-icon> {{ r.statusNote }}</button>
    }
  </ng-template>

  @if (listView.mode === 'cards') {
    <div class="inv-cards cat-cards">
      @for (r of dataSource.filteredData; track r.id) {
        <div class="cat-card">
          <div class="cat-card__head">
            <span class="cat-card__title">{{ r.folio }}</span>
            <span [class]="statusChip(r.status)">{{ r.status }}</span>
          </div>
          <div class="cat-card__body">
            <div class="cat-card__field"><span class="cat-card__label">Fecha:</span><span class="cat-card__value">{{ fmtDate(r.createdOn) }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Solicita:</span><span class="cat-card__value">{{ r.requestedBy || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Hospital:</span><span class="cat-card__value">{{ r._place }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Material:</span><span class="cat-card__value">{{ r._codes }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Se surte de:</span><span class="cat-card__value">{{ r._plan || 'Sin asignar' }}</span></div>
            @if (r.neededBy) {<div class="cat-card__field"><span class="cat-card__label">Se necesita:</span><span class="cat-card__value" [class.flag]="r._late">{{ fmtDate(r.neededBy, false) }}</span></div>}
          </div>
          <div class="cat-card__actions">
            <button mat-icon-button [matMenuTriggerFor]="cm" matTooltip="Acciones"><mat-icon>more_vert</mat-icon></button>
            <mat-menu #cm="matMenu"><ng-container *ngTemplateOutlet="rowMenu; context: { $implicit: r }"></ng-container></mat-menu>
          </div>
        </div>
      }
      @if (dataSource.filteredData.length === 0) { <p class="inv-cards__empty">Sin solicitudes con estos filtros</p> }
    </div>
  }

  <div class="table-container mat-elevation-z2" [hidden]="listView.mode !== 'table'">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="folio">
        <th mat-header-cell *matHeaderCellDef>Folio</th>
        <td mat-cell *matCellDef="let r"><code class="folio-badge">{{ r.folio }}</code></td>
      </ng-container>
      <ng-container matColumnDef="createdOn">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let r" class="nowrap">{{ fmtDate(r.createdOn) }}</td>
      </ng-container>
      <ng-container matColumnDef="place">
        <th mat-header-cell *matHeaderCellDef>Hospital</th>
        <td mat-cell *matCellDef="let r">{{ r._place }}</td>
      </ng-container>
      <ng-container matColumnDef="warehouse">
        <th mat-header-cell *matHeaderCellDef>Locker</th>
        <td mat-cell *matCellDef="let r">{{ r._warehouse || '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="requestedBy">
        <th mat-header-cell *matHeaderCellDef>Solicita</th>
        <td mat-cell *matCellDef="let r">{{ r.requestedBy || '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="lines">
        <th mat-header-cell *matHeaderCellDef>Material</th>
        <td mat-cell *matCellDef="let r">{{ r._codes }}</td>
      </ng-container>
      <ng-container matColumnDef="progress">
        <th mat-header-cell *matHeaderCellDef>Se surte de</th>
        <td mat-cell *matCellDef="let r">
          <div class="progress"><div class="progress__bar"><div class="progress__fill" [style.width.%]="r._pct"></div></div><span>{{ r._planned }}/{{ r._qty }}</span></div>
          <span class="sub">{{ r._plan || 'Sin asignar' }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="neededBy">
        <th mat-header-cell *matHeaderCellDef>Se necesita</th>
        <td mat-cell *matCellDef="let r" class="nowrap" [class.flag]="r._late">{{ fmtDate(r.neededBy, false) || '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let r"><span [class]="statusChip(r.status)">{{ r.status }}</span></td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let r" class="nowrap">
          @if (canSupply && (r.status === 'Nueva' || r.status === 'En surtido')) {
            <button mat-icon-button color="primary" matTooltip="Surtir: ver dónde hay el material" (click)="supply(r)"><mat-icon>travel_explore</mat-icon></button>
          }
          <button mat-icon-button [matMenuTriggerFor]="tm" matTooltip="Más acciones"><mat-icon>more_vert</mat-icon></button>
          <mat-menu #tm="matMenu"><ng-container *ngTemplateOutlet="rowMenu; context: { $implicit: r }"></ng-container></mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;" class="table-row"></tr>
      <tr class="no-data-row" *matNoDataRow>
        <td [attr.colspan]="columns.length"><div class="no-data"><mat-icon>assignment</mat-icon><span>Sin solicitudes con estos filtros</span></div></td>
      </tr>
    </table>
  </div>
</div>
